import React from 'react';
import { FiLoader } from 'react-icons/fi';
import logo from '../logo.png';

export default function Loading() {
  return (
    <div style={{ marginTop: '10em' }}>
      <div className="d-flex flex-wrap vertical-align justify-content-center mb-5 mt-5">
        <img src={logo} alt="" width="179" height="120" className="mx-2" />
      </div>
      <div className="d-flex flex-wrap vertical-align justify-content-center mb-5 mt-5">
        <h1 className="my-auto font-weight-bold title-404 text-center title">
          Loading
        </h1>
      </div>
      <div className="text-center">
        <FiLoader size="70px" />
      </div>
    </div>
  );
}
